import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { HeaderComponent } from '../../../shared/header/header.component';

@Component({
  selector: 'app-architecture-analysis',
  standalone: true,
  imports: [RouterLink, HeaderComponent],
  templateUrl: './architecture-analysis.component.html',
  styleUrls: ['./architecture-analysis.component.scss']
})
export class ArchitectureAnalysisComponent {}
